module.exports = "<div class=\"container-fluid\">\n\n    <app-header *ngIf=\"token\"></app-header>\n\n    <alert></alert>\n\n    <router-outlet></router-outlet>\n\n    <app-footer></app-footer>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/fulfillment.release/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 0